const formatter = (locale: string) => new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" });

export const formatDateTime = (isoString: string, locale: string): string =>
  formatter(locale).format(new Date(isoString));
